import { isUndefined } from 'lodash'
import { useState, useEffect } from 'react'
import { QueryListFilter } from '@feedyou-ai/feedbot-schema'

import { Preset, getPresetOptionForDateTimeFilter } from './utils'

export function useDateTimePresetOption({ toTimestamp, fromTimestamp }: QueryListFilter) {
  const [value, setValue] = useState<Preset | undefined>(undefined)
  useEffect(() => {
    if (isUndefined(value) && toTimestamp && fromTimestamp) {
      setValue(getPresetOptionForDateTimeFilter({ toTimestamp, fromTimestamp }))
    }
  }, [value, toTimestamp, fromTimestamp])

  return { value, setValue }
}
